import React, { FC } from 'react';

import { useTranslations } from '@lang';

import { useBodyScrollLock } from '@common/hooks/useBodyScrollLock';
import { useActiveMenu, MENU_IDS } from '@common/contexts/ActiveMenuContext';
import { StyledWrapper } from './Menu.styles';
import { Button } from './Button';

import { Items, ItemsProps } from './Items';

type MenuProps = ItemsProps;

export const Menu: FC<MenuProps> = ({
  isLoggedIn,
  isRoomsIntegrated,
  isTablesIntegrated,
  isRetailEnabled,
  isSpaTreatmentEnabled,
  isFacilitiesEnabled,
  isSpaClassesEnabled,
  isSpaDaysEnabled,
  websiteUrl,
}) => {
  const { t } = useTranslations();
  const { activeMenuId, toggleMenu: toggleActiveMenu } = useActiveMenu();
  const isMenuOpen = activeMenuId === MENU_IDS.MAIN_MENU;
  const targetRef = useBodyScrollLock(isMenuOpen);

  const toggleMenu = () => {
    toggleActiveMenu(MENU_IDS.MAIN_MENU);
  };

  return (
    <>
      <Button ariaLabel={t('aria.toggleMenu')} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <StyledWrapper isVisible={isMenuOpen} onClick={toggleMenu} ref={targetRef}>
        <Items
          isLoggedIn={isLoggedIn}
          isRoomsIntegrated={isRoomsIntegrated}
          isTablesIntegrated={isTablesIntegrated}
          isRetailEnabled={isRetailEnabled}
          isSpaTreatmentEnabled={isSpaTreatmentEnabled}
          isFacilitiesEnabled={isFacilitiesEnabled}
          isSpaClassesEnabled={isSpaClassesEnabled}
          isSpaDaysEnabled={isSpaDaysEnabled}
          websiteUrl={websiteUrl}
        />
      </StyledWrapper>
    </>
  );
};
